import React from "react";
import ReactDOM from "react-dom";
import GoalServices from "./../../../../services/goal.services";
import { WbEventHandlerMixins } from "../../../../utils/common.js";
import DeleteCommonModal from '../../../../components/deleteCommonModal.component';
import BasicKrComp from "../basicKrComponent";
import EditMetric from "../editMetric.component";
import { withTranslation } from "react-i18next";
import { Button } from '@workboard/wobo-ui';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import { formatNumber } from "../../../../utils/numberFormat";
import { ClosedKrLockContext } from '../closedKrLock.context';

class NestedInlineComp extends React.Component {
  static contextType = ClosedKrLockContext;

  constructor(props) {
    super(props);
    this.state = {
      newChildKr: props.newNestedKr ? props.newNestedKr : false,
      confirmDialog: false,
      metricToBeOperated: null,
      indexToBeOperated: null,
      clusterItem: this.props.clusterItem || [],
      editNestedKrId: null,
      isStretchEnabled: this.props.addOkrData.isStretchEnabled ??  this.props.goalDetails.isStretchEnabled ?? false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleErrorChange = this.handleErrorChange.bind(this);
    this.filterTeamFunctions = this.filterTeamFunctions.bind(this);
    this.setRightPaneValue = this.setRightPaneValue.bind(this);
    this.GoalServices = new GoalServices();
    this.clickEvent = this.clickEvent.bind(this);
    this.targetClick = this.targetClick.bind(this);
    this.teamPermissionData = this.teamPermissionData.bind(this);
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.updateKRDataObject = this.updateKRDataObject.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.clickEvent, false);
    if(!this.props.comingFromTest) {
      $(".goalPopupNew").css("overflow", "hidden");
    }
  }

  permissionData = (perData) => {
    this.setState({
      permissionstate: perData
    });
  }

  teamPermissionData(teamPerData) {
    this.setState({
      teamPermissionSelected: teamPerData
    });
  }

  bizPermissionData = (bizPerData) => {
    this.setState({
      bizPermissionSelected: bizPerData
    });
  }

  updateDataProvider = (data) => {
    this.setState({
      data_provider: {
        id: data.userId,
        name: data.userText,
        avatar: data.userPic
      }
    })
  }


  toggleConfirmDialog = (data, index) => {
    if(data) {
      this.setState({editNestedKrId: data.id || data})
    }
    setTimeout(() => {
      this.setState((prevState) => {
        return {
          confirmDialog: !prevState.confirmDialog,
          metricToBeOperated : data ? data : null,
          indexToBeOperated: index ? index : null
        }
      })
    }, 200)
  }

  deleteNestedKr = () => { 
    this.toggleConfirmDialog();
    this.closeKrRightPane();
    if(this.state.metricToBeOperated){
      this.props.updateNestedKrs(this.state.metricToBeOperated, "delete", this.state.indexToBeOperated);
    } else {
      this.addAnotherChildKr(false);
    }
  }

  saveNestedKr = (metric, index, action = "add") => {
    this.props.updateNestedKrs(metric, action, index);
    this.closeKrRightPane();
    this.addAnotherChildKr(false);
    this.setState({
      clusterItem: []
    })
    
  }

  editMetricCompFun = (inlineData, krItem, krType="person", index, action = "add") => {
    let item, newInlineData;
    if(krItem){
      if(krItem.id){
        item = {
          ...krItem,
          clusterItems: krItem,
          clusterCount: krItem.length
        }
      }else{
        item = {
          ...krItem,
          clusterItems: krItem,
          clusterCount: krItem.length
        };
        if(!inlineData){
          newInlineData = {
            ...krItem
          }
        }else{
          newInlineData = inlineData
        }
      }
    }
    
    this.advancedFunc(krType, item, newInlineData, index, action);
  }

  updateKRDataObject(val, item, inlineKRData, index, action)
  {
    let krType = WbEventHandlerMixins.getKrType(item.source, item.type, item.ext_app_id);
    this.advancedFunc(krType, {...item, name: val}, inlineKRData, index, action);
  }

  advancedFunc = (krType, krItem, inlineData, index, action) => {
    let basicInlineData = [];
    this.setState({editNestedKrId: krItem.id})
    if (typeof inlineData != "undefined") {
      basicInlineData = inlineData;
    }
    let kType;
    kType = WbEventHandlerMixins.getKrType(krItem.source, krItem.type, krItem.ext_app_id);
    ReactDOM.render(
      <EditMetric
        isChildKr = {true}
        childKrIndex = {undefined}       
        nestedKrAction = {action}
        nestedKrIndex = {index}
        parent = {this.props.item && this.props.item.id ? this.props.item.id : ""}
        addOkrData={this.props.addOkrData}
        goalDetails={this.props.goalDetails}
        goalType={this.props.goalType}
        krType={kType ? kType : "person"}
        closeKrRightPane={this.closeKrRightPane}
        item={krItem}
        krDelete={this.toggleConfirmDialog}
        addKrValue=""
        basicInlineData={basicInlineData}
        MetricChangeWeight={this.MetricChangeWeight}
        cancelKrInfo={this.closeKrRightPane}
        onlyMetEdit = {this.props.onlyMetEdit}
        showRealOwner = {this.props.showRealOwner}
        saveNestedKr = {this.saveNestedKr}
        actions = {this.props.actions}
        updateNestedKrs = {this.props.updateNestedKrs}
        integrations={this.props.addOkrData.integrations}
        updateKRDataObject={this.updateKRDataObject}
        fromParentKr
      />,
      document.getElementById("mySideChildKrs")
    );
  }

  MetricChangeWeight = (paramKr) => {
    let { actions } = this.props;
    if (paramKr) {
      actions.updateKrWeight(paramKr);
    }
  }



  updateAllStates = () => {
    this.setState({
      krListEn: true,
      // addNotherKr: true,
      ErrorDis: false,
      btnState: false,
      setKr: true,
      advanceOptionEn: true,
      addKrValue: "",
      krNameText: "",
      deleteKrList: false,
      deleteKrId: "",
      krTextField:
        this.props.goalDetails &&
        this.props.goalDetails.metrics !== undefined &&
        Object.keys(this.props.goalDetails.metrics).length > 0
          ? false
          : true,
      addKrFinished: false,
      addNotherKr:
        this.props.goalDetails &&
        this.props.goalDetails.metrics !== undefined &&
        Object.keys(this.props.goalDetails.metrics).length > 0
          ? true
          : false
    });
   // $(".basicTextplace").val("");
    let krtext = "";
    this.props.krTextWithOutsave(krtext);
    if (this.state.krRightPaneDelete) {
      ReactDOM.unmountComponentAtNode(document.getElementById("mySideChildKrs"));
    }
  }

  closeKrRightPane = (check, krId) => {
    if (document.getElementById("mySideChildKrs")) {
      ReactDOM.unmountComponentAtNode(document.getElementById("mySideChildKrs"));
    }
    $(".goalPopupNew").css("overflow", "initial");
    return overflowHiddenFunction(false);
  }



  clickEvent(e) {
    if (
      !$(".metricmeasureArea").is(e.target) &&
      $(".metricmeasureArea").has(e.target).length === 0
    ) {
      if (this.state.MeasureEn) {
        this.setState({
          MeasureEn: false
        });
      }

    }
    if (
      !$(".krTimeRange").is(e.target) &&
      $(".krTimeRange").has(e.target).length === 0
    ) {
      if (this.state.intervalEn) {
        this.setState({
          intervalEn: false
        });
      }
    }
    if (
      !$(".ownerKrName").is(e.target) &&
      $(".ownerKrName").has(e.target).length === 0 &&
      (!$(".myownerAlign ").is(e.target) &&
        $(".myownerAlign").has(e.target).length === 0)
    ) {
      if (this.state.krOwnerEn) {
        this.setState({
          krOwnerEn: false
        });
      }
    }
    if (
      !$(".CalculateOverDropDown").is(e.target) &&
      $(".CalculateOverDropDown").has(e.target).length === 0
    ) {
      if (this.state.porgressEn) {
        this.setState({
          porgressEn: false
        });
      }
    }
    if (
      !$(".krTimeRange").is(e.target) &&
      $(".krTimeRange").has(e.target).length === 0
    ) {
      if (this.state.intervalEn) {
        this.setState({
          intervalEn: false
        });
      }
    }
    if (
      !$(".metricTimeRange").is(e.target) &&
      $(".metricTimeRange").has(e.target).length === 0
    ) {
      if (this.state.dayEn) {
        this.setState({
          dayEn: false
        });
      }
    }
    if (!$(".aEPermissionList").is(e.target) &&
      $(".aEPermissionList").has(e.target).length === 0) {
      if (this.state.permissonEn || this.state.subPermissonEn) {
        this.setState({
          permissonEn: false,
          subPermissonEn: false
        });
      }
    } else {//for opening popup scroll to down.
      setTimeout(() => {
        var $target = $('.krRightPaneContent');
        if ($('.permissionContent').length) {
          $target.animate({ scrollTop: $('.krRightPaneContent').scrollTop() + 150 }, 1000);
        }
        if ($('.teamPermission').length) {
          $target.animate({ scrollTop: $('.krRightPaneContent').scrollTop() + 250 }, 1000);
        }
      }, 1);

    }
    if (
      !$(".metricTargetValue").is(e.target) &&
      $(".metricTargetValue").has(e.target).length === 0
    ) {
      if (this.state.metricDD) {
        this.setState({
          metricDD: false
        });
      }
    }
  }

  addAnotherChildKr = (bool) => {
    this.setState({
      newChildKr: bool,
    }, () => {
      this.props.addAnotherNestedKr(bool, false);
      const target = document.getElementById("addKrValueTxtId");
      target && target.focus();
    });
  }

  inlineKrUpdate = (newName) => {
    this.setState({
      addKrValue: newName
    });
  }

  handleChange(e) {
    //console.log(e.target.value);
    //let errors = {};
    const pattern = /^(\.)?[0-9,-]+(\.\d{0,10})?$/;

    let name = e.target.name;
    let value = e.target.value;

    const state = this.state;
    if (value === "" || pattern.test(value)) {
      state[name] = value;
      this.setState(state);
    }
    if (value === "" || pattern.test(value)) {
      this.setState({ errors: "" });
    }
  }

  handleErrorChange(name, value) {
    const state = this.state;
    state[name] = value;
    this.setState(state);
  }

  filterTeamFunctions(event) {
    this.setState({
      _isTeamMounted: true
    });
    event.preventDefault();
    let input, filter;
    let _this = this;
    input = document.getElementById("TeamSearch");
    filter = input.value.toLowerCase();
    filter[0] === " " ? filter[0].replace(" ", "") : filter;
    filter[filter.length - 1] === " "
      ? filter[filter.length - 1].replace(" ", "")
      : filter;
    if (filter.length > 1) {
      this.GoalServices.searchTeamName({ term: filter }).then(function (
        response
      ) {
        if (response.data && _this.state._isTeamMounted) {
          //console.log('GET', response.data);
          _this.setState({
            _isTeamMounted: false,
            filter: {
              Team: [...response.data]
            }
          });
        }
      });
    } else {
      _this.setState({
        _isTeamMounted: false,
        filter: {
          Team: []
        }
      });
    }
  }

  selectTeam(event, valTeam) {
    let _this = this;
    _this.setState({
      teamSearchText: valTeam.name,
      for_0: valTeam.id,
      subPermissonEn: false
    });
  }

  setRightPaneValue() {
    this.props.closeKrRightPane(false,this.state.krId);
  }


  exitDeleteModal() {
    this.setState({ confirmPopup: false, intervalConfirmPopup: false });
  }
  
  

  targetClick(e, id) {
    this.setState({
      dsMetric: id,
      errors: {}
    });
  }


	returnNumberSuffix = (number) => {
    if (number == "" || number == null || number == "undefined") {
      return 0;
    }
    return formatNumber(number);
  }

	getSymbol = (metricType) => {
    let textMetric = "";
    if (metricType == 1) {
      textMetric = "";
    } else if (metricType == 2) {
      textMetric = "";
    } else if (metricType == 3) {
      textMetric = "%";
    }
    return textMetric;
  }

	metricText = (metric) => {
    let textMetric = "";
    if (metric == 1) {
      textMetric = "number";
    } else if (metric == 2) {
      textMetric = "currency";
    } else if (metric == 3) {
      textMetric = "percentage";
    }
    return textMetric;
  }

	dayFunction(weekly_update_day = 5) {
    let whichDay = "";
    //console.log('weekly_update_day', weekly_update_day);
    if (weekly_update_day == 1) {
      whichDay = "every Monday";
    } else if (weekly_update_day == 2) {
      whichDay = "every Tuesday";
    } else if (weekly_update_day == 3) {
      whichDay = "every Wednesday";
    } else if (weekly_update_day == 4) {
      whichDay = "every Thursday";
    } else if (weekly_update_day == 5) {
      //console.log('INSIDE INTERVAL', weekly_update_day);
      whichDay = "every Friday";
    } else if (weekly_update_day == 6) {
      whichDay = "every Saturday";
    } else if (weekly_update_day == 7) {
      whichDay = "every Sunday";
    }
    return whichDay;
  }

	intervalText(interval, weekly_update_day) {
    let intervalMetric = "";
    if (interval == 1) {
      intervalMetric = "daily";
    } else if (interval == 2) {
      //console.log('INSIDE INTERVAL', interval,weekly_update_day);
      intervalMetric = this.dayFunction(weekly_update_day);
    } else if (interval == 3) {
      intervalMetric = "monthly";
    } else if (interval == 4) {
      intervalMetric = "quarterly";
    } else if (interval == 5) {
      intervalMetric = "once";
    }
    return intervalMetric;
  }

  durationText = (metrics) => {
    const { duration, parent } = metrics;
    return duration ? `${duration.name}${" "}` : (
      parent ? 'Custom ' : ''
    );
  }

	metadataText = (metrics) => {
    if(metrics.source == 11 && metrics.metricMirror && metrics.metricMirror.length > 0){
      metrics = {
        ...metrics,
        ...metrics.metricMirror[0]
      };
    }
    const { t } = this.props;
    let first = "";
    let second = "";
    let ownerName = metrics.owner_fullname  ? metrics.owner_fullname : metrics.ownerName;
    let stretchTarget = metrics.stretch_target ?? metrics.stretchTarget
    let achieveTarget =
      (metrics.achieve_target == "" || metrics.achieve_target == null
        ? metrics.initial_data ? metrics.initial_data : 0
        : this.returnNumberSuffix(Number(metrics.achieve_target))) +
      this.getSymbol(metrics.metric);
    let onlyTarget =
      (metrics.target == "" || metrics.target == null
        ? " of  " + 0
        : " of  " + this.returnNumberSuffix(Number(metrics.target))) +
      this.getSymbol(metrics.metric);
    if (this.state.isStretchEnabled) {
      onlyTarget = onlyTarget + (stretchTarget == "" || stretchTarget == null
        ? ""
        : " -  " + this.returnNumberSuffix(Number(stretchTarget)) +
        this.getSymbol(metrics.metric)) 
    }
    first =
      metrics.counting == 4 &&
      metrics.lower_limit &&
      achieveTarget +
        " of " +
        this.returnNumberSuffix(Number(metrics.lower_limit)) +
        " - ";
    second =
      metrics.counting == 4 &&
      metrics.upper_limit &&
      this.returnNumberSuffix(Number(metrics.upper_limit));
    //console.log('first', first, 'second', second, 'achieveTarget', achieveTarget, 'onlyTarget', onlyTarget);
    if (metrics.source == 5) {
      achieveTarget =
        (metrics.achieve_target == "" || metrics.achieve_target == null
          ? 0
          : this.returnNumberSuffix(Number(metrics.achieve_target))) +
        this.getSymbol(metrics.metric);
      onlyTarget =
        (metrics.target == "" || metrics.target == null
          ? " of  " + 0
          : " of  " + this.returnNumberSuffix(Number(metrics.target))) +
        this.getSymbol(metrics.metric);
      if (
        metrics.measure_metric_data == 3 ||
        metrics.measure_metric_data == 4
      ) {
        achieveTarget = achieveTarget + "%";
        onlyTarget = onlyTarget + "%";
      } else {
        achieveTarget = achieveTarget;
        onlyTarget = onlyTarget;
      }
      if (this.state.isStretchEnabled) {
        onlyTarget = onlyTarget + (stretchTarget == "" || stretchTarget == null
          ? ""
          : " -  " + this.returnNumberSuffix(Number(stretchTarget))) 
        if (metrics.measure_metric_data == 3 ||
            metrics.measure_metric_data == 4) {
            onlyTarget = onlyTarget + "%";
        }
      }
      first =
        metrics.counting == 6 &&
        metrics.lower_limit &&
        achieveTarget +
          " of " +
          this.returnNumberSuffix(Number(metrics.lower_limit)) +
          " - ";
      second =
        metrics.counting == 6 &&
        metrics.upper_limit &&
        this.returnNumberSuffix(Number(metrics.upper_limit));
    }
    if ((metrics.source == 3 || 1) && metrics.type == 2) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          { this.durationText(metrics) }
          <span className="dotClass"></span>{" "}
          {t('Cascaded participants to update')} {this.metricText(metrics.metric)}{" "}
          {this.intervalText(
            metrics.interval == null ? 0 : metrics.interval,
            metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
          )}{" "}
          <span className="dotClass"></span>{" "}
          {first != "" ? first : achieveTarget}
          {second != "" ? second : onlyTarget}
        </div>
      );
    } else if (metrics.source == 1) {
      return (
        <div className="krinfo inLineBlk verticalTop">
        { this.durationText(metrics) }
        <span className="dotClass"></span>{" "}
          {ownerName.length > 30
            ? ownerName.substr(0, 30) + "..."
            : ownerName}{" "}
          {t('to update')} {this.metricText(metrics.metric)}{" "}
          {this.intervalText(
            metrics.interval == null ? 0 : metrics.interval,
            metrics.weekly_update_day == null ? !metrics.id ? 5 : 0 : metrics.weekly_update_day
          )}{" "}
          <span className="dotClass"></span>{" "}
          {first != "" ? first : achieveTarget}
          {second != "" ? second : onlyTarget}
        </div>
      );
    } else if (metrics.source == 5) {
      if (metrics.counting == 6) {
        return (
          <div className="krinfo inLineBlk verticalTop">
           { this.durationText(metrics) }
            <span className="dotClass"></span>{" "}
            {t('Group of participants to update')} {this.metricText(metrics.metric)}{" "}
            {this.intervalText(
              metrics.interval == null ? 0 : metrics.interval,
              metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
            )}{" "}
            <span className="dotClass"></span>{" "}
            {first != "" ? first : achieveTarget}
            {second != "" ? second : onlyTarget}
          </div>
        );
      } else {
        return (
          <div className="krinfo inLineBlk verticalTop">
            { this.durationText(metrics) }
            <span className="dotClass"></span>{" "}
            {t('Group of participants to update')} {this.metricText(metrics.metric)}{" "}
            {this.intervalText(
              metrics.interval == null ? 0 : metrics.interval,
              metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
            )}{" "}
            <span className="dotClass"></span>{" "}
            {first != "" ? first : achieveTarget}
            {second != "" ? second : onlyTarget}
          </div>
        );
      }
    } else if (metrics.source == 10) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          { this.durationText(metrics) }
          <span className="dotClass"></span>{" "}
          {t('Sourcing data from DATA STREAM')} <span className="dotClass"></span>{" "}
          {first != "" ? first : achieveTarget}
          {second != "" ? second : onlyTarget}
        </div>
      );
    } else if (metrics.source == 8) {
      let textRendered = "",
        textRenderedVal = "";
      textRenderedVal =
        metrics.achieve_target == "" || metrics.achieve_target == null
          ? 0
          : this.returnNumberSuffix(Number(metrics.achieve_target));
      textRenderedVal =
        textRenderedVal +
        this.getSymbol(metrics.metric) +
        " of " +
        (metrics.target == null
          ? 0
          : this.returnNumberSuffix(Number(metrics.target)));
      textRenderedVal = textRenderedVal + this.getSymbol(metrics.metric);
      //console.log(metrics);
      if (metrics.ext_app_id) {
        if (metrics.ext_app_id == 5) {
          textRendered = "JIRA";
          textRenderedVal = metrics.achieve_target;
          if (metrics.metric == 3 || (metrics.metricJira && metrics.metricJira.qtype != "jql")) {
            textRenderedVal = metrics.progress + "%";
          }
        } else if (metrics.ext_app_id == 6) {
          textRendered = "ASANA";
        } else if (metrics.ext_app_id == 11) {
          textRendered = "MS PLANNER";
        } else if (metrics.ext_app_id == 13) {
          textRendered = "AZURE DEVOPS";
        } else if (metrics.ext_app_id == 15) {
          textRendered = "KR Studio"
        }
      }
      if (
        metrics.achieve_target == "" ||
        metrics.achieve_target == null ||
        metrics.achieve_target == "0" ||
        (metrics.target == "" ||
          metrics.target == null ||
          metrics.target == "0")
      ) {
        return (
          <div className="krinfo inLineBlk verticalTop">
            { this.durationText(metrics) }
            <span className="dotClass"></span>{" "}
            {t('Sourcing data from')} {textRendered} - {t('Collecting data')}...
          </div>
        );
      } else {
        return (
          <div className="krinfo inLineBlk verticalTop">
            { this.durationText(metrics) }
            <span className="dotClass"></span>{" "}
            {t('Sourcing data from')} {textRendered} <span className="dotClass"></span>{" "}
            {textRenderedVal}
          </div>
        );
      }
    } else if (metrics.source == 3) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          { this.durationText(metrics) }
          <span className="dotClass"></span>{" "}
          {t('Rolling up Key Results')} <span className="dotClass"></span>{" "}
          {achieveTarget} {onlyTarget}
        </div>
      );
    } else if (metrics.source == 7) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          { this.durationText(metrics) }
          <span className="dotClass"></span>{" "}
          {t('Rolling up other objectives')} <span className="dotClass"></span>{" "}
          {achieveTarget}
          {this.getSymbol(3)} {onlyTarget}
          {this.getSymbol(3)}
        </div>
      );
    } else if (metrics.source == 12 || metrics.source == 14) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          { this.durationText(metrics) }
            <span className="dotClass"></span>{" "}
          {t('Multiple targets')} |{" "}
          {ownerName.length > 30
            ? ownerName.substr(0, 30) + "..."
            : ownerName}{" "}
          {t('to update')} {this.metricText(metrics.metric)}{" "}
          {this.intervalText(
            metrics.interval == null ? 0 : metrics.interval,
            metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
          )}{" "}
          <span className="dotClass"></span> {achieveTarget} {onlyTarget}
        </div>
      );
    } else if (metrics.source == 13) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          { this.durationText(metrics) }
          <span className="dotClass"></span>{" "}
          {t('Multiple targets | Sourcing data from DATA STREAM')}{" "}
          <span className="dotClass"></span>{" "}
          {first != "" ? first : achieveTarget}
          {second != "" ? second : onlyTarget}
        </div>
      );
    } else if (metrics.source == 11) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          { this.durationText(metrics) }
          <span className="dotClass"></span>{" "}
          {t('Rolling up other objectivesto update')} {" "}
          {this.metricText(metrics.metric)}{" "}
          {this.intervalText(
            metrics.interval == null ? 0 : metrics.interval,
            metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
          )}{" "}
          <span className="dotClass"></span>{" "}
          {metrics.achieve_target == null ? 0 : metrics.achieve_target}
          {this.getSymbol(metrics.metric)} of {metrics.target}
          {this.getSymbol(metrics.metric)}
        </div>
      );
    } else if (metrics.source == 2) {
      let _achieveTarget = "";
      // console.log(typeof metrics.total_target);
      let _totalTarget =
        metrics.metric == 3
          ? (metrics.total_target && typeof metrics.total_target === "undefined"
              ? metrics.target
              : metrics.total_target) + "%"
          : typeof metrics.total_target === "undefined"
          ? metrics.target
          : metrics.total_target;
      if (metrics.achieve_target == -1) {
        _achieveTarget = "--";
      } else {
        _achieveTarget =
          metrics.metric == 3
            ? metrics.achieve_target + "%"
            : metrics.achieve_target;
      }
      if (metrics.metric == 3) {
        _achieveTarget = metrics.progress != -1 ? metrics.progress + "%" : "--";
      }
      return (
        <div className="krinfo inLineBlk verticalTop">
          { this.durationText(metrics) }
            <span className="dotClass"></span>{" "}
          {t('Measuring workstream activity for completion percentage')}{" "}
          <span className="dotClass"></span>
          {_achieveTarget} {metrics.metric == 4 ? ` ${t('of')} ` + _totalTarget : ""}
        </div>
      );
    }
  }

  updateClusterData = (resp) => {
    this.setState({
        clusterItem: resp
    })
  }

  render() {
    const {t, actions, addOkrData} = this.props;
    const {display_kr_clustering, isEnabledBiweeklyKR } = addOkrData
    const isClosedKr = this.context
    
    return (
      <>
      {
        (this.props.nested_krs && this.props.nested_krs.length > 0) || this.state.newChildKr ?
        <>
          <div className="fieldcontent" style={this.props.style ? this.props.style : {}}>
            <div role='heading' aria-level='2' className="labeltext-27px">{`${t('SUPPORTING QUARTERLY KEY RESULTS')}`}</div>
          </div>
          <div className="nestedKrWrapper">
            {this.props.nested_krs && this.props.nested_krs.length > 0 && 
              <>
              {
                this.props.nested_krs.map((metric, index) => (
                <div className="nestedKrListSec" key={metric.id ? metric.id : `${metric.name}_${index}` }>
                  <div className="nestedKrItem">
                    <div className="rectangle" ></div>
                    <div className="info">
                      <div className="primaryText">
                        {metric.name}
                      </div>
                      <div className="meta">
                        {this.metadataText(metric)}
                      </div>
                    </div>
                    {!isClosedKr && (
                      <div className="controls">
                        <div
                          className="editKrIcon" data-testid="editKrIcon"
                          onClick={() => this.editMetricCompFun(null, metric, "",  index, "update")}
                        ></div>
                        <div
                          className="deleteKrIcon"
                          // onClick={() => this.deleteNestedKr(metric)}
                          onClick={() => this.toggleConfirmDialog(metric, index, "delete")}
                        ></div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
              {
                !this.state.newChildKr && !isClosedKr &&
                <div className="newKrAdd"  data-testid="newKrAdd">
                  <div
                    className="inLineBlk cursor-pointer"
                    onClick={() => this.addAnotherChildKr(true)}
                  >
                    <div className="icon icon-outline-add_circle_outline-24px-blue " data-testid="addicon"></div>
                    <div className="add-another-kr" data-testid="add-another-kr">{t('Add another key result')}</div>
                  </div>
                </div>
              }
              </>
            }
            
            {
              //Basic KR Panel for new KR Creation
              this.state.newChildKr &&
              <div className="RectangleKrLeft">
                <div className="marginTop29"></div>
                  <BasicKrComp
                    isChildKr = {true}
                    //addKrValue={this.state.name}
                    deleteItems={this.deleteItems}
                    saveKrArr={this.props.saveKrArr}
                    saveKrs={this.saveNestedKr}
                    goalDetails={this.props.goalDetails}
                    resetKr={this.toggleConfirmDialog}
                    id=""
                    editMetricCompFun={this.editMetricCompFun}
                    inlineKrUpdate={this.inlineKrUpdate}
                    displayKrClustering={display_kr_clustering}
                    isEnabledBiweeklyKR={isEnabledBiweeklyKR}
                    updateKRStates={this.updateAllStates}
                    actions={actions}
                    clusterItem={this.state.clusterItem[0] && this.state.clusterItem[0].cKR ? this.state.clusterItem[0].cKR : []}
                    updateClusterData={this.updateClusterData}
                    t={this.props.t}
                  />
              </div>
            }
            <div className="krBreak" aria-hidden="true" />
          </div>
        </>
        :
        <div data-testid="aEOptionDescSec">
           <Button
              style={{ padding: '4px 4px 4px 0px', fontSize: '14px', fontWeight: 700}}
              kind="normal"
              onClick={() => this.addAnotherChildKr(true)}
              variant="ghost"
              isDisabled={isClosedKr}
              className="krAlign-label"
              startIcon={<AddIcon
                style={{
                  cursor: 'pointer',
                  width: '18px',
                  color: '#596373',
                  fontWeight: 700,
                  margin: '0px 0px 0px 4px',
                }}
              />}
            >
            {t('Supporting Quarterly Key Results')}
          </Button>
        </div>
      }
      <div id="mySideChildKrs"></div>
      {
        this.state.confirmDialog
          && (
          <DeleteCommonModal
            exitDeleteModal={this.toggleConfirmDialog}
            deleteItems={this.deleteNestedKr}
            title={this.state.editNestedKrId ? t(`Delete Supporting Key Result`) : t("Exit without saving")}
            deleteContentOne={t("Are you sure you want to")}
            deleteContentSecond={t(`leave without saving your key result?`)}
            nestedButton={this.state.editNestedKrId ? t("Delete") : t("Exit")}
            deleteContentSecondParam={t(`delete key result?`)}
            deletefirstTitle={this.state.editNestedKrId ? t('Delete Supporting Key Result') : t("Exit without saving")}
            deleteContentBodyText={t(`Are you sure you want to delete this supporting key result? This cannot be undone.`)}
            id={this.state.metricToBeOperated && this.state.metricToBeOperated.id ? this.state.metricToBeOperated.id :  this.state.metricToBeOperated }
          />
          )
      }
      </>
    );
  }
}

export default withTranslation()(NestedInlineComp)